import React from "react";
import { useTranslation } from "react-i18next";
import { Body1, SparkIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import AddSubtask from "./AddSubtask.jsx";
import { CompletedSubtasksContainer } from "./CompletedSubtasksContainer.jsx";
import SubtaskList from "./SubtaskList.jsx";
import SubtasksBodyTemplate from "./SubtasksBodyTemplate.jsx";
import { AiButton } from "../AiButton/AiButton.js";

const SubtasksBodyWithItems = ({
  taskId,
  projectId,
  convertToTaskReact,
  subtaskIds,
  onCancel,
  force,
  isTaskCompleted,
  onSuggest,
  showSuggestButton,
  visible,
}) => {
  const { t } = useTranslation();

  return (
    <SubtasksBodyTemplate>
      <div className="object_subtasks_inner">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-2">
          <Body1 weight="bold">{t("Subtasks")}</Body1>
          {showSuggestButton && visible ? (
            <AiButton onClick={onSuggest}>
              <SparkIcon className="tw-h-4 tw-w-4" />
              <span>{t("Suggest Subtasks")}</span>
            </AiButton>
          ) : null}
        </div>
        <div className="object_subtasks_open">
          <SubtaskList
            taskId={taskId}
            projectId={projectId}
            convertToTaskReact={convertToTaskReact}
            subtaskIds={subtaskIds}
          />
          <div className="tw-flex-col">
            {!isTaskCompleted ? (
              <AddSubtask
                taskId={taskId}
                projectId={projectId}
                force={force}
                onCancel={onCancel}
              />
            ) : null}
          </div>
          <CompletedSubtasksContainer
            taskId={taskId}
            isTaskCompleted={isTaskCompleted}
          />
        </div>
      </div>
    </SubtasksBodyTemplate>
  );
};

SubtasksBodyWithItems.propTypes = {
  taskId: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  convertToTaskReact: PropTypes.func,
  subtaskIds: PropTypes.array,
  onCancel: PropTypes.func,
  isTaskCompleted: PropTypes.bool,
  force: PropTypes.bool,
  onSuggest: PropTypes.func,
  showSuggestButton: PropTypes.bool,
  visible: PropTypes.bool,
};

SubtasksBodyWithItems.defaultProps = {
  convertToTaskReact: () => {},
  subtaskIds: [],
  onCancel: () => {},
  isTaskCompleted: false,
  force: false,
  onSuggest: () => {},
};

SubtasksBodyWithItems.displayName = "SubtasksBodyWithItems";

export default SubtasksBodyWithItems;
